jQuery(document).ready(function($) {
	$('.pro-options .pro-option-header .js-swatch-display').click(function() {
        event.stopPropagation();
        $('.pro-options .pro-option-body').hide();
        $(this).closest('.pro-options').find('.pro-option-body').slideToggle();
    });
  
    $('body.template-product').click(function() {
        $('.pro-options .pro-option-body').hide();
    });

    $('body.template-product .cst-other-plastics a').attr('target', '_blank');

    $('.velaSidebar .sidebarListCategories li a.active').parents('li.hasSubCategory').addClass('parent-active');

  //Son: please do not remove this if conditions
  if($('body.template-product #ProductJson-vela-template-product').length > 0 ) {
    var cstPro = JSON.parse($('body.template-product #ProductJson-vela-template-product').html());

    $(window).on('load', function() {
        //Single Product: clicking thumbnail will change variants  
        $( "body.template-product a.product-single__thumbnail").click( function() {
            let imgId = $(this).data('imageid');
            let selectedId = $('select#productSelect').val();
            var productAvailable = $(this).data("available");
    console.log(productAvailable);
            if(productAvailable == false) {
              //$("#proFeaturedImage .sold-out-msg").show();
            } else {
              $("#proFeaturedImage .sold-out-msg").hide();
            }

            //check current thumbnail match with current variant
            for (let i = 0; i < cstPro.variants.length ; ++i) {
                let proVar = cstPro.variants[i];
                if (proVar.id == selectedId && proVar.featured_media && proVar.featured_media.id == imgId) {
                    console.log('current img');
                    return false;
                }
            }
            
            for (let i = 0; i < cstPro.variants.length ; ++i) {
              let proVar = cstPro.variants[i];
              if (proVar.featured_media && proVar.featured_media.id == imgId && proVar.available == true) {
                  if (proVar.id == selectedId) {
                      break;
                  }
                    
                  for(let ii = 0; ii < proVar.options.length; ++ii) {
                      let variantSel = "input[name='option-" + ii + "'][value='" + proVar.options[ii] +"']";
                      $(variantSel).trigger('click');
                      console.log('selector' + ii + ": ", variantSel);
                  }
                  break;
                  
              }
              console.log("indexes: ", i);
              
            }
        });  
    })
  }

});
